<template>
  <div class="exchange-ticker-dropdown">
    <client-only>
      <exc-dropdown
        :value="value"
        :options="options"
        :search-by="['ticker', 'label']"
        v-bind="$attrs"
        class="exchange-ticker-dropdown__currencies"
        size="s"
        name="currency"
        without-border
        label-disabled
        @input="$emit('input', $event)"
      >
        <template #empty>
          <exc-loader
            v-if="loading"
            class="ml-20 txt--main txt--12px mr-auto"
          />
          <span v-else class="txt txt--22px txt--height-20px txt--grey">
            {{ $t('exchange.select') }}
          </span>
        </template>
        <!-- for selected option -->
        <template #selected>
          <div class="flx flx--items-center">
            <exc-ticker-logo
              :src="value.image"
              :alt="value.ticker"
              size="s"
              class="dropdown-payment-item__logo mr-4"
            />
            <span class="txt--color-04 txt--weight-400">
              {{ value.ticker }}
            </span>
            <exc-label
              v-if="value.network"
              class="txt txt--10px txt--uppercase ml-2"
              translate-y="0"
              purple
              circle
            >
              {{ value.network }}
            </exc-label>
          </div>
        </template>

        <template #item="{ option }">
          <div class="exchange-ticker-dropdown__dropdown-item">
            <div
              :class="{
                'exchange-ticker-dropdown__item-active flx flx--center': selectedItem(
                  option,
                ),
              }"
              class="pr-12 pl-12 pt-10 pb-10 item-label-wrapper"
            >
              <div>
                <exc-coin-with-logo
                  :name="option.ticker"
                  :img="option.image"
                  :label="option.label"
                  :balance="
                    $store.state.auth.loggedIn && !hideBalance
                      ? option[balanceKey].greaterThan(0)
                        ? formatNumber(option[balanceKey])
                        : '0'
                      : undefined
                  "
                  size="s"
                  class="exchange-ticker-dropdown__option-desktop"
                />
                <div v-if="option.network" class="flx">
                  <exc-label
                    class="txt txt--10px txt--uppercase ml-40"
                    translate-y="0"
                    purple
                    circle
                  >
                    {{ option.network }}
                  </exc-label>
                </div>
              </div>
              <span
                v-if="selectedItem(option)"
                class="exchange-ticker-dropdown__item-active-icon"
              >
                <ChoosenIcon />
              </span>
            </div>
          </div>
        </template>
      </exc-dropdown>
    </client-only>
  </div>
</template>

<script>
import {
  ExcCoinWithLogo,
  ExcDropdown,
  ExcTickerLogo,
  ExcLoader,
  ExcLabel,
} from '@/components/common'
import { formatNumber } from '@/lib/utils'

export default {
  name: 'ExchangeTickerDropdownNew',
  components: {
    ChoosenIcon: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/icons/rdx-choosen-icon.svg?inline'
      ),
    ExcCoinWithLogo,
    ExcDropdown,
    ExcTickerLogo,
    ExcLoader,
    ExcLabel,
  },
  props: {
    loading: { type: Boolean, default: false },
    value: {
      // validator: v => v instanceof Object || v === null,
      type: Object,
      default: () => {},
    },
    balanceKey: {
      type: String,
      default: 'tradeAvailable',
    },
    hideBalance: {
      type: Boolean,
      default: false,
    },
    options: { type: Array, required: true },
  },
  methods: {
    formatNumber (v) {
      return formatNumber(v, { decimal: 8 })
    },
    selectedItem (option) {
      if (option.network) {
        return (
          option.label === this.value.label &&
          option.network === this.value.network
        )
      }
      return option.label === this.value.label
    },
  },
}
</script>

<style lang="scss" scoped>
.exchange-ticker-dropdown {
  ::v-deep .exc-base-dropdown__search {
    text-indent: toRem(10px);
    margin-right: auto;
  }

  &__item-active {
    width: 100%;
    background-color: rgba(23, 88, 245, 0.13);
    display: flex;
    justify-content: space-between;
  }

  &__selected,
  &__dropdown-item {
    display: flex;
    align-items: center;

    ::v-deep span {
      max-height: toRem(40px);
      overflow-y: hidden;
    }
  }

  &__selected_ticker {
    position: absolute;
  }

  &__currencies {
    height: 100%;
  }

  &__total {
    width: 50%;
  }

  &__selected-mobile,
  &__option-mobile {
    display: block;

    @include bp(l) {
      display: none;
    }
  }

  ::v-deep {
    .exc-base-dropdown__form-control span {
      padding-left: 0;
    }

    .exc-base-dropdown__form-control .exc-label {
      padding-left: toRem(4px);
    }
  }

  @include bp(0, 1300px) {
    ::v-deep .exc-coin-with-logo__label {
      display: none;
    }
  }

  &__item-active-icon {
    min-width: toRem(22px);
  }
}
</style>
